import React, { useState, useEffect } from 'react';
import { IconName, IconPrefix, library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  ChevronIcon,
  Header,
  HeaderIcon,
  HeaderTitle,
  SubItemLink,
  SubList,
} from './style';

library.add(faChevronRight, faChevronDown);

export interface AccordionSubItem {
  title: string;
  path: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export interface AccordionMenuItemProps {
  title: string;
  icon: [IconPrefix, IconName];
  subItems: AccordionSubItem[];
  active?: boolean;
  isSidebarOpen?: boolean;
  isTeiaHeader?: boolean;
}

export const AccordionMenuItem = ({
  title,
  icon,
  subItems,
  active,
  isSidebarOpen = true,
  isTeiaHeader = false,
}: AccordionMenuItemProps) => {
  const hasActiveSubItem = subItems.some((item) => item.active);
  const [isOpen, setIsOpen] = useState(Boolean(active || hasActiveSubItem));

  useEffect(() => {
    if (!isSidebarOpen) {
      setIsOpen(false);
    }
  }, [isSidebarOpen]);

  useEffect(() => {
    if (active || hasActiveSubItem) {
      setIsOpen(true);
    }
  }, [active, hasActiveSubItem]);

  const collapsed = !isSidebarOpen;

  if (collapsed) {
    return (
      <Header
        $collapsed
        isTeiaHeader={isTeiaHeader}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <HeaderIcon $collapsed icon={icon} />
      </Header>
    );
  }

  return (
    <>
      <Header
        isActive={active && !isOpen}
        isTeiaHeader={isTeiaHeader}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <HeaderIcon icon={icon} />
        <HeaderTitle>{title}</HeaderTitle>
        <ChevronIcon icon={['fas', isOpen ? 'chevron-down' : 'chevron-right']} />
      </Header>

      {isOpen && (
        <SubList>
          {subItems.map((item, index) => (
            <SubItemLink
              key={index}
              to={item.disabled ? '#' : item.path}
              isActive={item.active}
              isTeiaHeader={isTeiaHeader}
              className={item.disabled ? 'disabled' : ''}
              onClick={() => {
                item.onClick?.();
              }}
            >
              {item.title}
            </SubItemLink>
          ))}
        </SubList>
      )}
    </>
  );
};
